import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Reveal";
import { useSiteSettings } from "@/context/SettingsContext";

export const Faq = () => {
  const { settings } = useSiteSettings();
  return (
    <section id="faq" className="py-24 sm:py-32 bg-secondary/50" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow text-orange-500">FAQ</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">Good questions, straight answers.</h2>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3">
            {(settings?.faqs || []).map((f, i) => (
              <AccordionItem key={i} value={`f${i}`} className="rounded-2xl border border-border bg-card px-6" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-lg font-semibold hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
